/* global s */
'use strict';


$(function() {
	if (!s.options.is_new_validator) {
		//extra validation methods
		$.validator.addMethod('regex', function (value, element, regexp) {
			const re = new RegExp(regexp, 'i');

			return this.optional(element) || re.test(value);
		}, 'Invalid pattern');
		$.validator.addMethod('over18', function (value) {
			const birth_day = new Date(value);
			const now = new Date();
			now.toLocaleString('en-US', {timeZone: 'America/New_York'})

			const y_now = now.getFullYear();
			const y_bday = birth_day.getFullYear();
			const y_diff = y_now - y_bday;

			if (y_diff === 18) {
				const m_bday = birth_day.getMonth();
				const m_now = now.getMonth();

				if (m_now === m_bday) {
					const d_now = now.getDate();
					const d_bday = birth_day.getDate();

					return d_bday >= d_now;
				} else {
					return m_bday >= m_now;
				}
			} else {
				return y_diff > 18;
			}
		});
		$.validator.addMethod('creditcard', function (value, element) {
			return this.optional(element) || s.validate_credit_card(value);
		});
		$.validator.setDefaults({
			errorPlacement: function (error, element) {
				if (element.parent().hasClass('input-group')) {
					error.insertAfter(element.parent());
				} else {
					error.insertAfter(element);
				}
			},
			submitHandler: function(form) {
				$(form)
					.find('[type=submit]:not([name])')
					.prop('disabled', true);
				form.submit();
			}
		});
		$.extend(jQuery.validator.messages, {
			required: s.options.messages.MANDATORY_FIELD
		});
	}
	/* default/fallback ajaxSetup */
	$.ajaxSetup({
		url: '/',
		type: 'post',
		dataType: 'json',
		data: {},
		beforeSend: function(jqXHR, settings) {
			if (settings.type === 'POST') {
				let token_value = $('form input[name="_token"]').val();
				let nothing_name = $('form input[name^="_nothing_"]').attr('name');

				if (typeof settings.data === 'undefined') {
					settings.data = '';
				}

				settings.data = s.common.getSecurityFields(settings.data, token_value, nothing_name);
			}
		},
		success: (data, textStatus, jqXHR) => {
			console.log(data, textStatus, jqXHR);
		},
		error: (jqXHR, textStatus, errorThrown) => {
			console.log(jqXHR, textStatus, errorThrown);
		},
		complete: (jqXHR, textStatus) => {
			console.log(jqXHR, textStatus);
		}
	});

	$('select.has-placeholder').on('change', function() {
		$(this).removeClass('has-placeholder');
	});

	$('[data-toggle="popover"]').popover();

	// checks for banners if they have countdown timers
	$.each($('._banner_timer'), function(i, banner_timer) {
		s.common.remaining_timer($(banner_timer));
	});

	$('.show-overflow-content').on('click', function() {
		let _this = $(this);
		let _overflow_text_container = _this;
		let _content = $($(this).attr('data-overflow-content'));
		if (_this.find('.overflow-trigger-text').length) {
			_overflow_text_container = _this.find('.overflow-trigger-text');
		}
		let _current_height = _content.get(0).scrollHeight;
		let _visible_height = _content.get(0).offsetHeight;
		if (!_this.hasClass('collapsed')) {
			_content.find('tr.d-none')
				.removeClass('d-none')
				.addClass('t-none');
			_content.animate({
				'max-height': _content.get(0).scrollHeight
			}, 700, function() {
				$(this).css({'max-height': 'none'});
				let _orig_text = _this.text();
				_overflow_text_container.text(_this.attr('data-alternative-text'));
				_this
					.data('original-height', _visible_height)
					.attr({
						'data-alternative-text': _orig_text,
						'aria-expanded': true
					})
					.addClass('collapsed');
			});
		} else {
			_content
				.css('max-height', _current_height)
				.animate({
					'max-height': _this.data('original-height')
				}, 700, function() {
					let _orig_text = _overflow_text_container.text();
					_overflow_text_container.text(_this.attr('data-alternative-text'));
					_this
						.attr({
							'data-alternative-text': _orig_text,
							'aria-expanded': false
						})
						.removeClass('collapsed');
					_content
						.find('tr.t-none')
						.removeClass('t-none')
						.addClass('d-none');
				});
			s.common.scrollToAnchor($(this).attr('data-overflow-content'), 240);
		}
	});

	/* Zone change */

	$('.zone-change-text').on('click', function() {
		const slider_text = $('.zone-change-text');
		const text_width = slider_text.width();
		let slider_input = $('.zone-change-input');
		let typeahead_zones = {};
		$.each(s.options.store_zones, (index, value) => {
			typeahead_zones[value.name] = value.id;
		});
		slider_input.html(
			$('<input>')
				.attr({
					id: 'zone-change-input',
					type: 'text',
					class: 'none',
					placeholder: s.options.messages.SEARCH_COUNTRY,
					autocomplete: 'off'
				})
				.css({
					'width': '0',
					'height': '2.1rem'
				})
		);
		slider_text.animate({opacity: 0, width: 0}, 300, () => {
			slider_text.addClass('none');
		});
		let searchInput = slider_input.find('input');
		let outerWidth = searchInput.attr('placeholder').length * 8;
		outerWidth = outerWidth < 130 ? 130 : outerWidth;

		searchInput
			.removeClass('none')
			.animate(
				{
					opacity: 1,
					width: outerWidth,
					padding: '0.2rem 0.4rem'
				}
			);

		searchInput.trigger('focus');
		searchInput.on('blur', function () {
			$(this).val('');
			searchInput.animate({opacity: 0, width: 0, padding: 0}, 300, () => {
				searchInput.removeClass('focus').addClass('none');
			});
			slider_text
				.animate({opacity: 1, width: text_width+10}, 300)
				.removeClass('none');
		});
		new autoComplete({
			minChars: 2,
			selector: '#zone-change-input',
			cache: 0,
			menuClass: 'zone-autocomplete',
			source(term, suggest) {
				term = term.toLowerCase();
				let search_array = [];
				let matches = [];
				for (let country_name in typeahead_zones ) {
					search_array.push(country_name);
				}
				for (let i=0;i<search_array.length;i++) {
					if (~search_array[i].toLowerCase().indexOf(term)) {
						matches.push(search_array[i]);
					}
				}
				suggest(matches);
			},
			onSelect(e, term, item) {
				window.location.href = s.url('/change_zone', {zone: typeahead_zones[term]});
			}
		});
	});

	let body = $('body,html');
	let scrollAnimationTime = 600;

	$.fn['SmoothSlideDown'] = function() {
		$(this).css({
			'transition': 'all .6s',
			'display': 'block',
			'height': $(this).prop('scrollHeight') + 'px'
		});
	};

	$.fn['SmoothSlideUp'] = function() {
		$(this)
			.css({
				'transition': 'all .6s',
				'min-height': 'inherit',
				'height': $(this).prop('scrollHeight') + 'px'
			})
			.delay(5)
			.queue(function (next) {
				$(this).css('height', 0);
				next();
			});
	};

	/* CONTACT SECTION */
	/* Contact section - Task #17542
		- Lead the customers to the help center page instead of opening the section
		- keep the logic here since we might bo back to the previous functionality soon
	 */

	/*
	let contactContainer = $('#contact-container');
	contactContainer.on(
		'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
		(e) => {
			let target = $(e.target);

			if (target.attr('id') === 'contact-container') {
				if (target.height() !== 0) {
					target
						.css({
							'transition': 'none',
							'min-height': target.prop('scrollHeight') + 'px'
						})
						.css('height', 'auto');
				} else {
					target.css({'display': 'none'});
				}
			}
		}
	);

	$('.help-center-btn').on('click', function() {
		let btnType = $(this).find('svg:not(.d-none)').attr('data-name');
		let btnContainer = $('.help-center-btn');
		let needHelpSpinner = $('#header-need-help-spinner');

		$(this).find('svg:not(.d-none)').addClass('d-none');

		s.common.closeMenuLoginRegisterSection();
		s.common.closeMobileMenu();

		switch (btnType) {
			case 'default':
				if (contactContainer.hasClass('has-content')) {
					body.animate(
						{scrollTop: 0},
						body.scrollTop() > 0 ? scrollAnimationTime : 0,
						() => {
							contactContainer.SmoothSlideDown();
							btnContainer.find("[data-name='close']").removeClass('d-none');
						}
					);
				} else {
					needHelpSpinner.removeClass('d-none');
					if (s.options.page_ajax.header_contact_form) {
						s.options.page_ajax.header_contact_form.abort();
					}

					s.options.page_ajax.header_contact_form = $.ajax({
						type: 'post',
						url: s.url('contact'),
						dataType: 'json',
						data: {
							action: 'raw_req'
						},
						success: (response) => {
							body.animate(
								{scrollTop: 0},
								body.scrollTop() > 0 ? scrollAnimationTime : 0,
								() => {
									contactContainer.html(response);

									if (typeof HelpCenterSearch !== 'undefined') {
										new HelpCenterSearch(helpCenterSearchParams);
									}

									if (typeof ContactForm !== 'undefined') {
										new ContactForm(contactFormParams);
									}

									contactContainer.SmoothSlideDown();
									contactContainer.addClass('has-content');
									needHelpSpinner.addClass('d-none');
									btnContainer.find("[data-name='close']").removeClass('d-none');
								}
							);
						},
						error: () => {
							needHelpSpinner.addClass('d-none');
							s.common.closeMenuHelpSection();
						}
					});
				}
				break;

			case 'close':
				s.common.closeMenuHelpSection();
				break;
		}
	});
	/* END CONTACT SECTION */

	$('.register-popover').popover({
		container : 'body'
	});

	/* MENU */
	$('#products-container').on('hide.bs.collapse', function () {
		$('.overlay').remove();
		let footer_navbar = $('#footer-navbar');
		if (!footer_navbar.find('.chevron-large-down-footer-nav').hasClass('flipped')) {
			footer_navbar.find('.chevron-large-down-footer-nav').addClass('flipped');
		}
	});
	$('#products-container').on('show.bs.collapse', function () {
		let footer_navbar = $('#footer-navbar');
		if (footer_navbar.find('.chevron-large-down-footer-nav').hasClass('flipped')) {
			footer_navbar.find('.chevron-large-down-footer-nav').removeClass('flipped');
		}
		$(this).css('z-index',9999);
	});
	$(document).on('click',  'body', function () {
		$('#products-container').collapse('hide');
	});
	$('#mobile-menu').on('click focusout', function() {
		let navbar = document.querySelectorAll('.navbar-kc')[0];
		let mobileMenu = $(document.getElementById('mobile-menu'));


		if (!navbar.classList.contains('active')) {
			//ios fix for closing mobile menu flicker
			$(navbar).css('min-height', $(navbar).outerHeight());

			//ios fix for position fixed mobile menu scroll + hide
			if (s.options.is_iOS) {
				body
					.scrollTop(0)
					.addClass('mobile-position-fixed-width100');
			}
		}

		navbar.classList.toggle('active');

		if (navbar.classList.contains('active')) {
			s.common.closeMenuLoginRegisterSection();
			s.common.closeMenuHelpSection();
			body.addClass('no-scroll-mobile');

			$(navbar).find('.navbar-kc-inner').scrollTop(0); //reset scroll
			mobileMenu.find('.icon-menu-hamburger')[0].classList.add('d-none');
			mobileMenu.find('.icon-menu-close')[0].classList.remove('d-none');
		} else {
			s.common.closeMenuLoginRegisterSection();
			s.common.closeMenuHelpSection();
			s.common.closeMobileMenu();
		}
	});

	$('#body').on('click tap', function () {
		mobileMenu.find('.icon-menu-hamburger')[0].classList.add('d-none');
		mobileMenu.find('.icon-menu-close')[0].classList.remove('d-none');
	});



	(function () {
		function calculate_slide_factor (main_menu_height, scroll_top, offset) {
			let threshhold = main_menu_height + offset;
			let slide_factor = 0;

			if (scroll_top < threshhold) {
				slide_factor =
					scroll_top < threshhold - main_menu_height - offset
						? offset
						: - (scroll_top - threshhold + main_menu_height);
			} else {
				slide_factor =
					scroll_top > threshhold + main_menu_height
						? 0
						: - main_menu_height + (scroll_top - threshhold);
			}

			return slide_factor;
		}

		let body = $('body,html');
		let nav_wrapper = $('#nav-wrapper');
		let main_menu = $('.navbar-kc');
		let main_menu_height = 0;
		let banner = $('.banner');
		let slide_factor = 0;
		let scroll_top = 0;
		let offset = 0;

		$(window).on('scroll resize', function() {
			if (!body.hasClass('no-scroll-mobile') || window.innerWidth > 991.98) {
				main_menu_height = main_menu.outerHeight();
				scroll_top = $(document).scrollTop();
				offset = banner.length > 0 ? banner.outerHeight() : 0;
				slide_factor = 0;

				/*if ($(window).width() > 992) {
					slide_factor = calculate_slide_factor(main_menu_height, scroll_top, offset);
				}*/

				nav_wrapper.css({'min-height': (offset < scroll_top ? main_menu_height : 0) + 'px'});
				main_menu.css({
					'position': offset < scroll_top ? 'fixed' : '',
					'top': slide_factor + 'px'
				});
			}
		});

		$(window).trigger('scroll');
	})();
	/* END MENU */

	/* LOGIN/REGISTER */
	(function () {
		let loginRegisterBtn = document.getElementById('login-register-menu-btn');
		let loginRegisterContainer = $(document.getElementById('login-register-container'));
		let loginHolder = document.getElementById('login-holder');
		let registerHolder = document.getElementById('register-holder');

		if (loginRegisterContainer) {
			loginRegisterContainer.on(
				'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
				(e) => {
					let target = $(e.target);
					if (target.attr('id') === 'login-register-container') {
						if (target.height() !== 0) {
							target
								.css({
									'transition': 'none',
									'min-height': target.prop('scrollHeight') + 'px'
								})
								.css('height', 'auto');
						} else {
							target.css({'display': 'none'});
						}
					}
				}
			);
		}

		if (loginRegisterBtn) {
			loginRegisterBtn.addEventListener('click', () => {
				s.common.closeMenuHelpSection();
				loginRegisterBtn.classList.toggle('active');
				loginRegisterBtn.classList.toggle('hover-active');
				loginRegisterContainer.toggleClass('active');

				if (loginRegisterContainer.hasClass('active')) {
					body.animate(
						{scrollTop: 0},
						body.scrollTop() > 0 ? scrollAnimationTime : 0,
						() => {
							registerHolder.style.display = 'none';
							loginHolder.style.display = '';
							loginRegisterContainer.SmoothSlideDown();
						}
					);
				} else {
					s.common.closeMenuLoginRegisterSection();
				}
			});

			loginRegisterBtn.addEventListener('mouseenter', () => { loginRegisterBtn.classList.add('hover-active'); });
			loginRegisterBtn.addEventListener('mouseleave', () => { loginRegisterBtn.classList.remove('hover-active'); });
		}
	})();
	/* END LOGIN/REGISTER */

	/* FOOTER COOKIES CONSENT BANNER */
	(function () {
		try {
			const form = document.querySelector('#footer_overlay #form_consent');
			if (!form) return;

			form.addEventListener('submit', (e) => {
				e.preventDefault();
			});

			const user_consent = s.options.user_consent;
			const consent_groups = {
				'functionality': ['functionality_storage', 'security_storage'],
				'analytics': ['analytics_storage'],
				'marketing': ['ad_personalization', 'ad_user_data', 'ad_storage'],
			};
			const submit_buttons = form.querySelectorAll('button[name="submit_button"]');
			submit_buttons.forEach(button => {
				button.addEventListener('click', (e) => {
					const consent_choice = e.target.value;
					const inputs = form.querySelectorAll('input[type="checkbox"]:not(:disabled)');
					inputs.forEach(input => {
						switch (consent_choice) {
							case 'accept_all':
								input.checked = true;
								break;
							case 'deny':
								input.checked = false;
								break;
						}
						const consent_group = input.name;
						const consent_group_value = input.checked ? 'granted' : 'denied';
						if (consent_groups[consent_group]) {
							consent_groups[consent_group].forEach(consent_name => {
								user_consent[consent_name] = consent_group_value;
							});
						}
					});

					if (typeof gtag === 'function') {
						gtag('consent', 'update', user_consent);
					}

					const form_data = new FormData();
					form_data.append('consent', JSON.stringify(user_consent));
					form_data.append('consent_choice', consent_choice);
					s.common.fetcher(s.url('/process_consent'), { method: 'POST', body: form_data });

					setTimeout(() => {
						form.closest('#footer_overlay').remove();
					}, 250);
				});
			});
		} catch (error) {
			console.log('Cookies consent banner error: ', error);
		}
	})();
	/* END FOOTER COOKIES CONSENT BANNER */
});
